import { init } from "../init";
import { HomePage } from "../pages/home/home-page";
init(HomePage);
